import { Directive, HostListener } from '@angular/core';

/**
 * Place on an element that opens an ngx-bootstrap modal (typically the trigger
 * button). Prevents the host element from receiving keyboard focus on click by
 * suppressing the default focus behaviour of the `mousedown` event.
 *
 * Without this, the browser focuses the button on `mousedown`; after the
 * ngx-bootstrap modal opens and closes, focus is restored to the trigger,
 * leaving a focus ring on the button. Calling `event.preventDefault()` on
 * `mousedown` short-circuits the focus step entirely, so the button never
 * gains focus in the first place.
 */
@Directive({
  selector: '[appBlurOnModalClose]',
  standalone: true
})
export class BlurOnModalCloseDirective {
  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    event.preventDefault();
  }
}
